export const downloadCatalog = (catalogPath = "/atelier-catalog.pdf") => {
  const url = new URL(catalogPath, window.location.origin);
  url.searchParams.set("v", "809ae10c");
  const link = document.createElement("a");
  link.href = url.toString();
  link.download = "Atelier-Catalog-2026.pdf";
  link.dataset.testid = "catalog-file-download-link";
  document.body.appendChild(link);
  link.click();
  link.remove();
};